export default __webpack_public_path__ + "static/media/Ring of the Ponderous Lady.fe5d7109.jpg";